<svelte:options customElement={{
  tag: 'catch-copy',
  shadow: 'none',
  props: {
    variant: { reflect: true, type: 'String' },
    text: { reflect: true, type: 'String' }
  }
}} />

<script>
  /**
   * text3：キャッチコピー（強調文字）
   * パーツライブラリ準拠の mod-catch01 / mod-catch02 構造
   * @prop {string} variant - 'large' (mod-catch01) | 'small' (mod-catch02)
   * @prop {string} text - テキスト（slot未使用時のフォールバック）
   */
  export let variant = 'large';
  export let text = '';

  $: className = variant === 'small' ? 'mod-catch02' : 'mod-catch01';
</script>

<p class={className}>
  {#if text}
    {@html text}
  {:else}
    <slot></slot>
  {/if}
</p>
